var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"t-icon",class:[
    ("t-icon--" + _vm.type),
    { 't-icon--boxed': _vm.boxed } ]},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"size":_vm.size,"fixed-width":_vm.fixedWidth,"rotation":_vm.rotation,"flip":_vm.flip,"spin":_vm.spin,"pulse":_vm.pulse,"border":_vm.border,"pull":_vm.pull,"inverse":_vm.inverse,"swap-opacity":_vm.swapOpacity,"mask":_vm.mask}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }